import React, { useState } from "react";
import client from "@culturehq/client";
import { Button, Loader, Panel, Table } from "@culturehq/components";

import { useFetch, useIsMounted } from "app/hooks";
import { strftime, t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import PageHeader from "components/display/PageHeader";

import chrome from "images/browsers/chrome.png";
import edge from "images/browsers/edge.png";
import explorer from "images/browsers/explorer.png";
import firefox from "images/browsers/firefox.png";
import opera from "images/browsers/opera.png";
import safari from "images/browsers/safari.png";

const browsers = {
  Chrome: chrome,
  Edge: edge,
  Firefox: firefox,
  "Internet Explorer": explorer,
  Opera: opera,
  Safari: safari
};

const UserAgent = ({ userAgent }) => {
  const browser = userAgent.split("/")[0];

  return (
    <>
      {Object.prototype.hasOwnProperty.call(browsers, browser) && (
        <img
          className="Security__browser"
          src={browsers[browser]}
          alt={browser}
        />
      )}
      <span>{userAgent}</span>
    </>
  );
};

const prettyDate = timestamp => {
  if (strftime(timestamp, "%Y%m%d") === strftime(new Date(), "%Y%m%d")) {
    return `Today at ${strftime(timestamp, "%l:%M %p")}`;
  }
  return strftime(timestamp, "%Y/%m/%d %l:%M %p");
};

const Security = () => {
  const { error: listError, fetching, json: { apiKeys = [] } } = useFetch(client.listApiKeys);
  const isMounted = useIsMounted();

  const [invalidatable, setInvalidatable] = useState(true);
  const [invalidateError, setInvalidateError] = useState(null);

  const onInvalidate = async () => {
    setInvalidatable(false);

    try {
      await client.invalidateOtherApiKeys();

      if (isMounted) {
        setInvalidatable(true);
        await client.listApiKeys();
      }
    } catch (error) {
      if (isMounted) {
        setInvalidatable(true);
        setInvalidateError(error);
      }
    }
  };

  const error = listError || invalidateError;

  return (
    <Panel limitWidth>
      <Panel.Heading primary>
        <Trans>Security</Trans>
      </Panel.Heading>
      <Panel.Body>
        <PageHeader title={t("Active Sessions")}>
          <Trans>
            Below is a list of your currently active CultureHQ session across
            all devices. On this page, you may sign out from every other active
            session, making your current session the only one active.
          </Trans>
        </PageHeader>
        {apiKeys && apiKeys.length > 1 && (
          <p>
            <Button primary onClick={onInvalidate} disabled={!invalidatable}>
              <Trans>Sign out other sessions</Trans>
            </Button>
          </p>
        )}
        {error && <ErrorMessage error={error} />}
        <Loader loading={fetching}>
          <Table>
            <thead>
              <tr>
                <th><Trans>Issued</Trans></th>
                <th><Trans>Last Used</Trans></th>
                <th><Trans>From</Trans></th>
              </tr>
            </thead>
            <tbody>
              {apiKeys.map(apiKey => (
                <tr key={apiKey.token}>
                  <td>{prettyDate(apiKey.createdAt)}</td>
                  <td>{prettyDate(apiKey.lastRequestAt)}</td>
                  <td>
                    {apiKey.lastRequestUserAgentDisplay && (
                      <UserAgent userAgent={apiKey.lastRequestUserAgentDisplay} />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Loader>
      </Panel.Body>
    </Panel>
  );
};

export default Security;
